import React, { Component } from 'react';
import "./footer.css";
export default class MobileFooter extends Component {

    render() {
        return (
            <footer className="container">
                <div className="col footerbox">
                    <div className="row">
                        <div className="col">
                            <h2>فـــردا به نـــوآوری نیــازمــند است</h2>
                        </div>
                    </div>
                    <div className="row">
                        <p className="mr-t-30 align-c txt-white copyright"><a href="https://www.havayar.com/">کلیه حقوق برای هوایار محفوظ است</a><i className="far fa-copyright"></i><span className="copyright-year">۱۴۰۱</span></p>
                    </div>
                </div>
            </footer>
        );
    }
}

